/* Shared plain-search tokenizer — used by BOTH the /api/masjids server filter and the
   directory client's re-filter so they can never disagree. The AI parse is an ENHANCEMENT;
   this is what makes plain search work on its own when the AI is unavailable.

   "masjid in Hyderabad" → ["hyderabad"] → matches Hyderabad rows. Terms are ANDed together;
   each term ORs across the searchable fields. Glue/stop words are dropped because a single
   full-phrase ILIKE ('%masjid in Hyderabad%') matches nothing. A query that is ALL stopwords
   (e.g. just "masjid") yields no terms → callers apply no text constraint (on a masjid
   directory, "masjid" honestly means "everything"). */

export const SEARCH_STOPWORDS = new Set([
  // the specified set
  'in', 'near', 'me', 'masjid', 'masjids', 'masajid',
  // common glue words that would otherwise AND-kill every multi-word query
  'a', 'an', 'the', 'of', 'at', 'with', 'and', 'for', 'to', 'my',
  // transliteration variants of the subject noun
  'mosque', 'mosques',
])

export function searchTerms(q: string): string[] {
  return q
    .toLowerCase()
    .split(/\s+/)
    .map((t) => t.replace(/^[^\p{L}\p{N}]+|[^\p{L}\p{N}]+$/gu, '')) // trim punctuation, keep unicode letters
    .filter((t) => t.length >= 2 && !SEARCH_STOPWORDS.has(t))
}
